import type { JSX, ReactNode } from 'react';
import * as Popover from '@radix-ui/react-popover';
import './index.scss';

interface UpPopoverProps {
  content: ReactNode;
  children: ReactNode;
  contentWidth?: string;
  arrowAlign?: 'start' | 'center' | 'end';
  contentSide?: 'top' | 'right' | 'bottom' | 'left';
}

function UpPopover({
  content,
  children,
  contentWidth = '',
  arrowAlign = 'center',
  contentSide = 'bottom',
}: UpPopoverProps): JSX.Element {
  return (
    <div className="inline-block">
      <Popover.Root>
        <Popover.Trigger asChild>
          <span>{children}</span>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            sideOffset={8}
            avoidCollisions
            side={contentSide}
            align={arrowAlign}
            collisionPadding={20}
            style={{ width: contentWidth }}
            className="up-popover-content">
            <div className="content-wrapper">{content}</div>
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
}

export default UpPopover;
